import { Logo, LogoFooter } from "iovisit-astermantova/components/layout";

import favicon from "iovisit-astermantova/static/favicon.ico";
import appleTouchIcon from "iovisit-astermantova/static/apple-touch-icon.png";
import favicon16 from "iovisit-astermantova/static/favicon-16x16.png";
import favicon32 from "iovisit-astermantova/static/favicon-32x32.png";
import safariPinnedTab from "iovisit-astermantova/static/safari-pinned-tab.svg";
import Favicon from "iovisit-astermantova/components/Favicon";
import AppExtras from "iovisit-astermantova/components/AppExtras";
import { IoVisitViews } from "iovisit-astermantova/config/views";
import { IoVisitBlocks } from "iovisit-astermantova/config/blocks";

const applyConfig = (config) => {
  config.settings.isMultilingual = false;
  config.settings.matomoSiteId = "kjpRRJYp1y";
  config.settings.matomoUrlBase = "https://ingestion.webanalytics.italia.it/";
  config.settings.iovisit.siteName = "";
  config.settings.iovisit.logo = Logo;
  config.settings.iovisit.logoFooter = LogoFooter;
  config.settings.iovisit.rightLink = {
    text: "Sito web Biblioteca Teresiana",
    url: "https://www.bibliotecateresiana.it/",
  };
  config.settings.iovisit.topLink = {
    text: "Comune di Mantova",
    url: "https://www.comune.mantova.it/",
  };
  config.settings.showWishlistWidget = false;
  config.settings.iovisit.siteHeadTitleName =
    "Portale accessibilità Biblioteca Teresiana";

  config.settings.iovisit.favicon = [
    { rel: "icon", sizes: "any", href: favicon },
    { rel: "icon", sizes: "16x16", href: favicon16 },
    { rel: "icon", sizes: "32x32", href: favicon32 },
    { rel: "apple-touch-icon", sizes: "180x180", href: appleTouchIcon },
    { rel: "mask-icon", color: "#000", href: safariPinnedTab },
  ];

  config.settings.appExtras.push({
    match: "",
    component: Favicon,
  });
  config.settings.appExtras.push({
    match: "",
    component: AppExtras,
  });

  IoVisitViews(config);
  IoVisitBlocks(config);

  config.settings["volto-gdpr-privacy"].defaultPanelConfig.last_updated =
    "2024-05-16T12:00:00+00:00";
  config.settings["volto-gdpr-privacy"].defaultPanelConfig.text.it.description =
    "Questo sito utilizza i cookie tecnici di navigazione e di sessione per garantire un miglior servizio di navigazione del sito, e cookie analitici per raccogliere informazioni sull'uso del sito da parte degli utenti.  Utilizza anche cookie di profilazione dell'utente per fini statistici. Per i cookie di profilazione puoi decidere se abilitarli o meno cliccando sul pulsante 'Impostazioni'. Per saperne di più, su come disabilitare i cookie oppure abilitarne solo alcuni, consulta la nostra <a href='/privacy-policy'>Cookie Policy</a>.";

  config.settings["volto-gdpr-privacy"].defaultPanelConfig.technical.choices = [
    {
      config_key: "MATOMO",
      text: {
        it: {
          title: "Matomo",
          description:
            "I cookie di Matomo sono usati per analizzare la navigazione sul sito al fine di migliorarla e fornire all'utente un'esperienza di navigazione migliore possibile.",
        },
        en: {
          title: "Matomo",
          description:
            "Matomo cookie are used to analyze navigation on the site in order to improve it and provide the user with the best possible browsing experience.",
        },
      },
    },
  ];

  return config;
};

export default applyConfig;
